import {
  ApiSourceOfTruthCustomizationValuesToIgnore,
  ApiSourceOfTruthCustomizationValuesToIgnoreSchema,
} from './valuesToIgnore';

export const ApiSourceOfTruthCustomizationValuesToAddSchema = ApiSourceOfTruthCustomizationValuesToIgnoreSchema;

export type ApiSourceOfTruthCustomizationValuesToAdd = ApiSourceOfTruthCustomizationValuesToIgnore;
